import BookCoverImage from "@/public_obituary/book/BookCoverImage"
import { useSelector } from "react-redux"
import { isAppInMaintenanceMode } from "@/components/common/Helpers"
import {useState} from 'react'
import {filled, value} from '../../components/common/Helpers'

export default function BookBlock({
    onViewBook,
    // Custom styling props with defaults
    titleText = "Celebrating The Life Of",
    titleClassName = "uppercase tracking-widest text-slate-500",
    nameClassName = "text-2xl font-serif",
    descriptionClassName = "text-lg mb-5",
    shareMemoryTitleClassName = "font-semibold text-slate-800 mb-2",
    shareMemoryDescriptionClassName = "text-sm max-w-xs",
    // Button styling props
    viewBookButtonProps = "shadow-sm border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 px-4 py-2 text-sm rounded-md inline-flex items-center justify-center font-medium focus:outline-none focus:ring-2 focus:ring-offset-2",
    buyBookButtonProps = "shadow-sm border border-transparent text-white bg-blue-600 px-4 py-2 text-sm rounded-md inline-flex items-center justify-center font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 hover:bg-blue-700",
    shareMemoryButtonProps = "shadow-sm border border-transparent text-white bg-slate-600 px-4 py-2 text-sm rounded-md inline-flex items-center justify-center font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 hover:bg-slate-700",
    // Container styling
    containerClassName = "rounded-lg bg-white shadow mb-10 overflow-hidden",
    leftSectionClassName = "flex w-full md:w-2/5 bg-gray-300 justify-center items-center",
    rightSectionClassName = "flex-1 p-6 flex-row content-center"
}) {
    const {
        obituary
    } = useSelector(state => state.obituaryReducer)

    const scrollToElement = (elementId) => {
        const targetElement = document.getElementById(elementId)
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }

    const [hasLegacy, setHasLegacy] = useState('gannettLegacy' in window)
    const legacyEvent = 'ecomm_click'

    if (isAppInMaintenanceMode()) {
        return <></>
    }

    const queryParams = ['ttm_origin', 'ttm_campaign']
    const params = new URLSearchParams(window.location.search)
    const bookUrl = filled(obituary?.book_sales_url) ? value(() => {
        return queryParams.reduce((url, param) => {
            const value = params.get(param)
            if (filled(value)) {
                url.searchParams.append(param, value)
            }
            return url
        }, new URL(obituary.book_sales_url)).toString()
    }) : null

    return (
        <div className={containerClassName}>
            <div className="md:flex gap-4 md:gap-10">
                <div className={leftSectionClassName}>
                    <div className="w-full max-w-[400px] p-16 py-5">
                        <BookCoverImage />
                    </div>
                </div>

                <div className={rightSectionClassName}>
                    <div className="mb-5">
                        <div className="flex-1 mb-2">
                            <div className={titleClassName}>
                                {titleText}
                            </div>
                            <div className={nameClassName}>{obituary?.display_name}</div>
                        </div>

                        <div className="flex items-center gap-3">
                            <button
                                onClick={onViewBook}
                                className={viewBookButtonProps}
                            >
                                View Book
                            </button>

                            <a
                                onClick={() => {
                                    if (hasLegacy) {
                                        gannettLegacy(legacyEvent, {'cta_text': 'Buy Book', 'destination_url': bookUrl ?? ''})
                                    }
                                }}
                                href={bookUrl}
                                target="_blank"
                                className={buyBookButtonProps}
                            >
                                Buy Book
                            </a>
                        </div>
                    </div>

                    <p className={descriptionClassName}>
                        A beautifully bound keepsake book filled with memories and condolences from family and
                        friends.
                    </p>

                    <div className="sm:flex gap-3 border-t border-gray-100 pt-5">
                        <div className="flex-1 mb-2">
                            <h3 className={shareMemoryTitleClassName}>Share Your Memory</h3>

                            <p className={shareMemoryDescriptionClassName}>
                                Contribute your memory to the online guestbook to be featured in this unique
                                keepsake
                                book.
                            </p>
                        </div>

                        <div className="content-center">
                            <button onClick={() => scrollToElement('tukios-obituary-guestbook')}
                                className={shareMemoryButtonProps}
                            >
                                Share Your Memory
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <style dangerouslySetInnerHTML={{
                __html: `
                      html { scroll-behavior: smooth; }
                      #tukios-obituary-guestbook { scroll-margin-top: 100px; }
                    `
            }}></style>
        </div>
    )
}
